export default __webpack_public_path__ + "static/media/notification-calendar.815e2ffb.svg";